import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-time",
  "use": "icon-time-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-time\"><g fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\"><path d=\"M1.71 9.835A5.999 5.999 0 007 13h0a6 6 0 10-6-6M6.667 4.83v3M9.167 7.83h-2.5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol